<template>
	<div class="tourist">
			<div class="tourist-guide">
				<div class="tourist-guide-content">
					<h3>{{ systemSetting.schoolName }}欢迎您!</h3>
					<div v-if="!token" class="line"></div>
					<button @click="login" v-if="!token">立即登录</button>
				</div>
				<span class="down" @click="scorlltopOne" v-if="!token"><i class="el-icon-arrow-down"></i></span>
			</div>
			<div><component class="tourist-components" v-for="com in comps" :key="com.name" :is="com.name" /></div>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import Serve from './Tourist/RecServe';
import News from './Tourist/NewList';
import { login } from '@/utils/utils'

export default {
	name: 'Tourist',
	components: {
		Serve,
		News
	},
	computed: {
		...mapGetters(['serveUrl', 'systemSetting', 'config', 'request', 'token', 'flowServeUrl'])
	},
	data() {
		return {
			comps: [
				{
					name: 'Serve'
				},
				{
					name: 'News'
				}
			]
		};
	},
	methods: {
		// 登录页面跳转idtoken/login
		login() {
			login();
		},
		scorlltopOne() {
			this.scrollWrapper = document.querySelector('.app-main-wrapper');
			let wrapper = this.scrollWrapper;
			let top = document.body.clientHeight - 0 - 60;
			let height = this.scrollWrapper.scrollTop || 0;
			let timer = setInterval(function() {
				if (height <= top) {
					height += 10;
					wrapper.scrollTop = height;
				} else {
					clearInterval(timer);
				}
			}, 1);
		}
	}
};
</script>
<style lang="scss">
@import '@/styles/variables.scss';

.tourist-guide {
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	height: calc(100vh - 60px);
	&-content {
		width: 100vw;
		display: flex;
		flex-direction: column;
		align-items: center;

		h3 {
			font-size: 44px;
			font-weight: 400;
			line-height: 44px;
			color: #fff;
			letter-spacing: 4px;
		}

		.line {
			width: 1px;
			height: 80px;
			margin: 20px 0;
			background-color: #fff;
		}

		button {
			width: 230px;
			height: 48px;
			background-color: rgba($color: $color-primary, $alpha: 0.9);
			border: 0px solid rgba($color: #fff, $alpha: 0.5);
			border-radius: 25px;
			font-size: 18px;
			color: #ffffff;
			font-weight: bold;

			&:hover {
				background: #fff;
				color: $color-primary;
			}
		}
	}

	.down {
		position: absolute;
		bottom: 50px;
		left: 50%;
		width: 38px;
		height: 38px;
		line-height: 34px;
		text-align: center;
		cursor: pointer;
		border: 2px solid #fff;
		border-radius: 100%;
		box-sizing: border-box;
		transform: translate3d(-50%, 0, 0);
		// animation: 0.45s ease 0s infinite alternate none running down;
		i {
			font-weight: 600;
			color: #fff;
		}
	}
}
.first-screen {
	width: 100%;
	& > div {
		max-width: 1920px;
		margin: 0 auto;
	}
}
.tourist-components {
	width: 100%;
	& > div {
		max-width: 1920px;
		margin: 0 auto;
	}
	min-height: calc(100vh - 60px);
}
</style>
